import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import { getCloudinaryImagePathById } from '../../../utilities/images';
import CreateContentPopupV2 from '../../Content/CreateContentWidgetV2/CreateContentPopup/CreateContentPopup';
import Button from '../../Input/Button/Button';
import './PostNow.scss';

export default class PostNow extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
        };
    }

    static propTypes = {
        Topics: PropTypes.array.isRequired,
        message: PropTypes.node.isRequired,
        btnText: PropTypes.string,
    };

    static defaultProps = {
        Topics: [],
        btnText: 'Post now',
    };

    render() {
        return (
            <div className="component-wrappers-PostNow">
                <div className="image-div">
                    <img
                        src={getCloudinaryImagePathById(
                            '/icons/handsup',
                            'medium'
                        )}
                    />
                </div>

                {this.props.message}

                <PageConsumer>
                    {(context) => {
                        <React.Fragment>
                            {context.wrapAuth(
                                'CreateContent',
                                <div className="post-btn">
                                    <Button
                                        type={'solid'}
                                        value={this.props.btnText}
                                        inputStyle="btn-italic"
                                        onClick={() => {
                                            context.isLoggedIn()
                                                ? this.setState({
                                                      showForm: !this.state
                                                          .showForm,
                                                  })
                                                : null;
                                        }}
                                    />
                                </div>,
                                { login_trigger: 'create-content' }
                            )}
                            <CreateContentPopupV2
                                topics={this.props.topics}
                                modal={this.state.showForm}
                                toggle={() =>
                                    this.setState({ showForm: false })
                                }
                            />
                        </React.Fragment>;
                    }}
                </PageConsumer>
            </div>
        );
    }
}
